 "use client";

import { useEffect } from "react";
import { RotateCcw, TriangleAlert } from "lucide-react";

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  useEffect(() => {
    console.error("Unhandled error:", error);
  }, [error]);

  return (
    <div className="container py-20 md:py-28">
      <div className="mx-auto max-w-2xl text-center">
        <div className="mx-auto mb-8 flex h-20 w-20 items-center justify-center rounded-[var(--radius-xl)] bg-[var(--color-error-50)]">
          <TriangleAlert className="h-9 w-9 text-[var(--color-danger-text)]" aria-hidden="true" />
        </div>
        <p className="eyebrow">Error 500</p>
        <h1 className="mt-4 font-[family-name:var(--font-display)] text-4xl font-semibold tracking-[-0.02em] text-[var(--color-text)] text-balance sm:text-5xl">
          Something went wrong
        </h1>
        <p className="mx-auto mt-4 max-w-md text-[var(--color-text-muted)]">
          An unexpected error occurred while rendering this page. Nothing you typed was sent
          anywhere — processing happens in your browser.
        </p>
        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <button
            onClick={() => reset()}
            className="inline-flex h-12 items-center gap-2 rounded-full bg-[var(--color-accent)] px-6 text-sm font-semibold text-[var(--color-accent-fg)] shadow-[var(--shadow-sm)] transition-all hover:bg-[var(--color-accent-hover)] hover:shadow-[var(--shadow-md)]"
          >
            <RotateCcw className="h-4 w-4" aria-hidden="true" />
            Try again
          </button>
        </div>
      </div>
    </div>
  );
}
